export const SIZE = {
  big: 'big',
  small: 'small',
} as const
